import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('InvBuyerRelation', InvBuyerRelationData);

    InvBuyerRelationData.$inject = ['$translate', '$filter', 'LegalEntity'];

    /* @ngInject */
    function InvBuyerRelationData($translate, $filter, LegalEntity) {
        InvBuyerRelation.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getEnabledServices: getEnabledServices,
        };

        function InvBuyerRelation(invBuyerRelationData) {
            if (!invBuyerRelationData) {
                this.buildEmpty();
            } else {
                this.build(invBuyerRelationData);
            }
        }

        return InvBuyerRelation;

        function buildEmpty() {
            this.principalName = null;
            this.seller = new LegalEntity();
            this.acceptation = null;
            this.creationDate = null;
            this.endOfValidity = null;
            this.enabledServices = null;
            this.sellerPrincipalCorporateName= null;
        }

        function build(relationData) {
            this.principalName = relationData.principalName || null;
            this.seller = new LegalEntity(relationData.seller);
            this.acceptation = relationData.acceptation ? $filter('date')(relationData.acceptation, 'shortDate') : null;
            this.endOfValidity = relationData.endOfValidity
                ? $filter('date')(relationData.endOfValidity, 'shortDate')
                : null;
            this.creationDate = relationData.creationDate
                ? $filter('date')(relationData.creationDate, 'shortDate')
                : null;
            this.enabledServices = relationData.enabledServices;
            this.sellerPrincipalCorporateName = relationData.sellerPrincipalCorporateName || null;
        }

        function getEnabledServices() {
            var val = '';
            if (this.enabledServices) {
                val = _.map(this.enabledServices, function (svc) {
                    return $translate.instant('principal.invbuy_enabled_service.' + angular.lowercase(svc));
                }).join(' et ');
            }
            return val;
        }
    }
})();
